import { useState } from 'react';

import Chevron from './Chevron';
import './Section.css';

function Section({ initiallyHidden = false, titleColor = null, ...props }) {
    const [ hidden, setHidden ] = useState(initiallyHidden);

    function toggleVisibility(e) {
        e.preventDefault();
        e.stopPropagation();
        setHidden(!hidden);
    }

    return (
        <section>
            <div className="title row noselect" onClick={toggleVisibility} >
                <p style={{ flex: 1, color: titleColor || (hidden ? '#aaa' : '#000') }}>{props.title || "<Untitled section>"}</p>
                <Chevron open={!hidden} />
            </div>

            <div className='column g32' style={{ width: '100%', display: hidden ? 'none' : '' }}>
                {props.children}
            </div>
        </section>
    );
};

export default Section;